import { memo } from 'react';

import { Box, Stack, useTheme } from '@chakra-ui/react';

import { formatRewardPoints } from 'utils';

import { Text } from 'ui';

interface RewardPointsProps {
  isMobile: boolean;
  points?: number | string | null;
}

const RewardPoints = ({ isMobile, points }: RewardPointsProps) => {
  const {
    colors: {
      palette: {
        components: { savingBlock: styles }
      }
    }
  } = useTheme();

  const display = formatRewardPoints(points);

  if (isMobile) {
    return (
      <Stack
        align='center'
        width='100%'
        minH='50px'
        backgroundColor={styles.bg}
        borderRadius={0}
        gap={0}
        overflow='hidden'
        py='10px'
        cursor='default'
      >
        <Box bg={styles.headerBg} w='100%' py='5px'>
          <Text
            fontSize='11px'
            textTransform='uppercase'
            color={styles.headerTextColor}
            textAlign='center'
          >
            Reward points
          </Text>
        </Box>
        <Text
          fontSize='22px'
          lineHeight='120%'
          fontWeight='semibold'
          textAlign='center'
          color={styles.amountColor}
        >
          {display}
        </Text>
      </Stack>
    );
  }

  return (
    <Stack
      align='center'
      width='100%'
      height='80px'
      backgroundColor={styles.bg}
      borderTopRadius={6}
      borderBottomRadius={0}
      gap={0}
      overflow='hidden'
      marginTop='15px'
      marginBottom='2px'
      cursor='default'
    >
      <Box bg={styles.headerBg} w='100%' py='5px'>
        <Text
          fontSize='11px'
          textTransform='uppercase'
          color={styles.headerTextColor}
          textAlign='center'
        >
          Reward points
        </Text>
      </Box>

      <Stack
        w='100%'
        height='100%'
        alignItems='center'
        justifyContent='center'
        gap={0}
      >
        <Text
          fontSize='22px'
          lineHeight='120%'
          fontWeight='semibold'
          textAlign='center'
          color={styles.amountColor}
        >
          {display}
        </Text>
      </Stack>
    </Stack>
  );
};

export default memo(RewardPoints);
